export interface State {
  hasDarkMode: boolean | null;
}

export const initialState: State = {
  hasDarkMode: null,
};
